<template lang="pug">
.d-flex
  .flex-grow-1
    filter-name.mr-2(ref="name" :filter.sync="nameFilter" check-initial-value)
    filter-age.mr-2(ref="age" :filter.sync="ageFilter" check-initial-value)
    filter-item.mr-2(ref="item" :filter.sync="itemFilter" check-initial-value)
    filter-status.mr-2(ref="paymentStatus" label="Payment status" :filter.sync="paymentStatusFilter" :statuses="paymentStatuses" check-initial-value multiple)
    filter-status.mr-2(ref="status" label="Reservation status" :filter.sync="statusFilter" :statuses="orderStatuses" check-initial-value multiple)
  v-btn.button-sm.underline.px-0(text @click="resetFilters" :disabled="allFilters.length === 0") Reset filters
</template>

<script>
import FilterName from '@/components/module/filter/FilterName.vue'
import FilterAge from '@/components/module/filter/FilterAge.vue'
import FilterStatus from '@/components/module/filter/FilterStatus.vue'
import FilterItem from '@/components/clinic/registration/FilterItem.vue'

export default {
  components: { FilterName, FilterAge, FilterStatus, FilterItem },
  props: {
    filters: { type: Array, default: () => [] },
    propFilters: { type: Object, default: null },
  },
  data: () => ({
    nameFilter: {},
    ageFilter: {},
    paymentStatusFilter: {},
    statusFilter: {},
    itemFilter: {},
    paymentStatuses: [
      { id: 'paid', name: 'Paid' },
      { id: 'unpaid', name: 'Unpaid' },
      { id: 'partially_refunded', name: 'Partially refunded' },
      { id: 'refunded', name: 'Refunded' },
    ],
    orderStatuses: [
      { id: 'active', name: 'Active' },
      { id: 'cancelled', name: 'Cancelled' },
    ],
  }),
  computed: {
    allFilters () {
      const filters = []
      if (this.nameFilter.key) {
        filters.push(this.nameFilter)
      }
      if (this.ageFilter.key) {
        if (this.ageFilter.key === 'between') {
          const values = this.ageFilter.value
          for (const i in values) {
            filters.push(values[i])
          }
        } else {
          filters.push(this.ageFilter)
        }
      }
      if (this.paymentStatusFilter.key) {
        filters.push({ key: 'payment_status', value: this.paymentStatusFilter.value })
      }
      if (this.statusFilter.key) {
        filters.push({ key: 'statuses', value: this.statusFilter.value })
      }
      if (this.itemFilter.key) {
        filters.push(this.itemFilter)
      }
      return filters
    },
  },
  watch: {
    allFilters (newValue) {
      this.$emit('update:filters', newValue)
    },
  },
  methods: {
    dataFilters () {
      return {
        nameFilter: this.nameFilter,
        ageFilter: this.ageFilter,
        paymentStatusFilter: this.paymentStatusFilter,
        statusFilter: this.statusFilter,
        itemFilter: this.itemFilter,
      }
    },
    setFilters () {
      this.nameFilter = this.propFilters?.nameFilter || {}
      this.ageFilter = this.propFilters?.ageFilter || {}
      this.paymentStatusFilter = this.propFilters?.paymentStatusFilter || {}
      this.statusFilter = this.propFilters?.statusFilter || {}
      this.itemFilter = this.propFilters?.itemFilter || {}
      this.$nextTick(() => {
        this.$refs.name.setData()
        this.$refs.age.setData()
        this.$refs.paymentStatus.setData()
        this.$refs.status.setData()
        this.$refs.item.setData()
      })
    },
    resetFilters () {
      this.nameFilter = {}
      this.ageFilter = {}
      this.paymentStatusFilter = {}
      this.statusFilter = {}
      this.itemFilter = {}
    },
  },
}
</script>
